import { functionsFetch } from "../utils/functionsFetch";

export const getAllAnalyticsCampaigns = async () => {
  try {
    const res = await functionsFetch({
      method: "GET",
      url: `/taxi-campaigns/analytics/all`,
    });

    return res.data;
  } catch (err) {
    alert(err.response.data.error);
    return Promise.reject(err.response.data);
  }
};
